<script>
import CustomIcon from 'dashboard/components/ui/CustomIcons.vue';

export default {
  name: 'SourceTypeBadge',
  components: {
    CustomIcon,
  },
  props: {
    type: {
      type: String,
      required: true,
    },
    brandName: {
      type: String,
      required: false,
    },
  },
  computed: {
    data() {
      const sourceTypes = {
        FACEBOOK: {
          label: 'Facebook',
          textColor: 'text-[#60646C]',
          bgColor: 'bg-[#F5F5F5]',
          iconColor: '#60646C',
        },
        INSTAGRAM: {
          label: 'Instagram',
          textColor: 'text-[#60646C]',
          bgColor: 'bg-[#F5F5F5]',
          iconColor: '#60646C',
        },
      };
      return (
        sourceTypes[this.type] || {
          label: 'Desconhecido',
          textColor: 'text-[#000000]',
          bgColor: 'bg-[#FFFFFF]',
          iconColor: '#000000',
        }
      );
    },
  },
};
</script>

<template>
  <div
    :class="`flex items-center justify-center gap-2 rounded-lg p-2 text-xs font-semibold ${data.bgColor} ${data.textColor}`"
  >
    <CustomIcon group="sourceType" :name="type" :color="data.iconColor" />
    <span>{{ brandName || data.label }}</span>
  </div>
</template>
